import { render } from "./DownCenter.vue?vue&type=template&id=08eef448&scoped=true"
import script from "./DownCenter.vue?vue&type=script&lang=js"
export * from "./DownCenter.vue?vue&type=script&lang=js"

import "./DownCenter.vue?vue&type=style&index=0&id=08eef448&lang=scss&scoped=true"

import exportComponent from "/data/devops/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08eef448"]])

export default __exports__